import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { LANGUAGES, LOCALES, COUNTRY_SHORT_NAMES } from 'config/constants';

import './LanguageSelector.scss';

@inject('AppState')
@observer
export default class LanguageSelector extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
	};

	componentDidMount() {
		document.addEventListener('click', this.handleDocumentClick.bind(this));
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleDocumentClick.bind(this));
	}

	@action
	handleDocumentClick() {
		if (!this.mouseWasDown && !this.mouseWasUp && this.expanded) {
			this.expanded = false;
		}

		this.mouseWasDown = false;
		this.mouseWasUp = false;
	}

	@observable selectedLanguage = this.getLanguage(this.props.AppState.locale);
	@observable expanded = false;
	mouseWasDown = false;
	mouseWasUp = false;

	@action
	toggle(e) {
		e.preventDefault();

		this.expanded = !this.expanded;
	}

	@action
	onClick(language) {
		this.selectedLanguage = language;
		this.props.AppState.setLocale(LOCALES[language]);
	}

	getLanguage(locale) {
		return Object.keys(LOCALES).find(key => LOCALES[key] === locale);
	}

	handleMouseDown() {
		this.mouseWasDown = true;
	}

	handleMouseUp() {
		this.mouseWasUp = true;
	}

	canSeeLanguageSelector() {
		return (
			this.props.AppState.user.country.short_name === COUNTRY_SHORT_NAMES.CA
		);
	}

	render() {
		if (!this.canSeeLanguageSelector()) {
			return null;
		}

		const { selectedLanguage, expanded } = this;

		return (
			<div className="navbar-controls navbar-right">
				<div className="LanguageSelector">
					<div
						className="LanguageSelector-container"
						onMouseDown={this.handleMouseDown.bind(this)}
						onMouseUp={this.handleMouseUp.bind(this)}
						onClick={this.toggle.bind(this)}
					>
						{selectedLanguage}
						<span className="arrow-icon" />
						{expanded &&
							<div className="LanguageSelector-container-content">
								{LANGUAGES.map((language, index) =>
									<div
										className={`LanguageSelector-container-content-country ${language ===
										selectedLanguage
											? 'selected'
											: ''}`}
										key={index}
										onClick={this.onClick.bind(this, language)}
									>
										{language}
									</div>
								)}
							</div>}
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/LanguageSelector/index.js